import currencyList from '@/const/currency'
export default (currency) => {
  return currencyList.find((item) => item.backCurrency === currency)
    ?.viewCurrency
}
